export const conventions = {
  DEFAULT: {
    locale: 'en-US',
    style: 'decimal',
    currencyDisplay: 'symbol', // symbol | code | name
    useGrouping: true,
    notation: 'standard', // standard | compact | scientific | engineering
    roundingMode: 'halfExpand',
    signDisplay: 'auto', // auto | always | never | exceptZero
    trailingZeroDisplay: 'auto', // auto | stripIfInteger
  },

  OSSINO: {
    // inherits all of DEFAULT; only per-currency precision overrides here
    currencies: {
      BTC: {
        inputPrecision: { min: 0, max: 8 },
        outputPrecision: { min: 2, max: 8 },
        balanceOutputPrecision: { min: 2, max: 8 },
      },
    },
  },
}
